<div class="header"
     mat-dialog-title>
  <h3>{{ title }}</h3>
</div>

<mat-dialog-content>
  <div class="messages">
      <txp-message [type]="messageType.DANGER"
                   data-qa-label="FormError"
                   *ngIf="showFormError">
        {{ 'store.storeHours.formInvalidMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="SaveError"
                 *ngIf="showError">
      {{ 'store.dayparts.saveErrorMsg' | translate }}
    </txp-message>
  </div>

  <txp-loading *ngIf="isSaving"
               [color]="loadingColor.COLOR"></txp-loading>

  <form [formGroup]="form" class="daypart-form" [hidden]="isSaving">
          <!-- Brand Level: Name and Decorators -->
          <ng-container *ngIf="!isStoreLevel && !isMenuLevel">
            <mat-form-field class="name">
              <mat-label>{{ 'menu.information.dayParts.name' | translate }}</mat-label>
              <input formControlName="name"
                      data-qa-label="NameInput"
                      required
                      matInput />
              <mat-error *ngIf="!form.get('name').errors?.nameExists">
                {{ 'form.error.required' | translate }}
              </mat-error>
              <mat-error *ngIf="form.get('name').errors?.nameExists">
                {{ 'menu.information.dayParts.nameExists' | translate }}
              </mat-error>
            </mat-form-field>

            <div class="localization-content">
                <h4 class="translations-header">{{ 'menu.information.translations' | translate }}</h4>
                <div class="instructions">{{ 'menu.information.translationsInstr' | translate }}</div>
                <txp-item-decorator-cva
                    formControlName="decorators"
                    [decoratorData]="decoratorData">
                </txp-item-decorator-cva>
            </div>
          </ng-container>

          <!-- Store Level or Menu Level: Daypart configuration -->
          <ng-container *ngIf="isStoreLevel || isMenuLevel">
            <!-- Daypart Template Dropdown (select which brand daypart to use) - FIRST -->
            <mat-form-field class="template">
                <mat-label>{{ 'store.dayparts.brandDaypartName' | translate }}</mat-label>
                <mat-select data-qa-label="DayPartId"
                            formControlName="daypartId"
                            [placeholder]="'store.dayparts.selectBrandDaypart' | translate"
                            required
                            matInput>
                <mat-option *ngFor="let daypart of availableBrandDayparts" [value]="daypart.id">
                    {{ daypart.name }}
                </mat-option>
             </mat-select>
                <mat-error *ngIf="form.get('daypartId')?.hasError('required')">
                    {{ 'form.error.required' | translate }}
                </mat-error>
            </mat-form-field>

            <!-- Decorators from selected brand daypart (show after selection, editable) -->
            <div class="localization-content" *ngIf="form.get('daypartId')?.value">
                <h4 class="translations-header">{{ 'menu.information.translations' | translate }}</h4>
                <div class="instructions">{{ 'menu.information.translationsInstr' | translate }}</div>
                <txp-item-decorator-cva
                    formControlName="decorators"
                    [decoratorData]="decoratorData"
                    [readOnly]="true">
                </txp-item-decorator-cva>
            </div>

            <!-- Hours Template Selection (shows after selecting a daypart) -->
            <mat-form-field class="template" *ngIf="form.get('daypartId')?.value">
                <mat-label>{{ 'menu.information.dayParts.template' | translate }}</mat-label>
                <mat-select data-qa-label="HoursTemplateSelect"
                            formControlName="hoursTemplate"
                            matInput
                            (selectionChange)="onTemplateChange($event.value)">
                  <mat-option *ngFor="let template of templateList" [value]="template">
                    {{ template.name }}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Hours Configuration (shows after selecting a daypart) -->
            <txp-store-hours-template-form *ngIf="form.get('daypartId')?.value"
                                            formControlName="hours"
                                            class="store-hours-template-form">
            </txp-store-hours-template-form>
          </ng-container>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="actions">
  <txp-button (click)="onCancel()"
              [hidden]="readOnly"
              data-qa-label="CancelButton"
              [style]="buttonStyle.SECONDARY">
    {{ 'form.button.cancel' | translate }}
  </txp-button>
  <txp-button (click)="saveDaypart()"
              [hidden]="readOnly"
              data-qa-label="AddOrUpdateButton"
              [disabled]="form.pristine"
              [style]="buttonStyle.PRIMARY">
    {{ 'menu.information.dayParts.addOrUpdate' | translate }}
  </txp-button>
</mat-dialog-actions>
